// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/mouse-pointer-2.js';

import { paths } from '../generated/mouse-pointer-2';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('mouse-pointer-2', Original, paths);
